import script from "./InfoTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoTable.vue?vue&type=script&lang=ts&setup=true"

import "./InfoTable.vue?vue&type=style&index=0&id=6cc72671&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc72671"]])

export default __exports__